<template>
  <div class="mb-10">
    <v-simple-table>
      <template v-slot:default>
        <tbody>
          <tr v-for="item in detail.psp_peringkat_jenjangs" :key="item.psp_peringkat_jenjang_id">
            <td>
              <v-row>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="warning" size="60">
                      <v-icon dark>mdi-google-classroom</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <span class="caption grey--text">Jenjang</span>
                      <div class="subtitle-2 blue--text">
                        {{ $getDeepObj(item, 'm_jenjang.singkat') }}
                        ({{ $getDeepObj(item, 'm_jenjang.keterangan') }})
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="my-2">
                    <div><span class="caption grey--text">Ajuan persentase di Sekolah negeri dan swasta</span></div>
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <span class="pink--text">Negeri: </span>
                        <span class="subtitle-1 font-weight-bold">{{ $getDeepObj(item, `persen_negeri`) || 0 }}%</span>
                      </v-col>
                      <v-col cols="12" md="6">
                        <span class="orange--text text--darken-3">Swasta: </span>
                        <span class="subtitle-1 font-weight-bold"> {{ $getDeepObj(item, `persen_swasta`) || 0 }}%</span>
                      </v-col>
                    </v-row>
                    <div><span class="caption grey--text">Jumlah KS negeri dan jumlah KS swasta</span></div>
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <span class="pink--text">Negeri: </span>
                        <span class="subtitle-1 font-weight-bold">
                          {{ $getDeepObj(item, `jml_kasek_negeri`) || 0 }}
                        </span>
                      </v-col>
                      <v-col cols="12" md="6">
                        <span class="orange--text text--darken-3">Swasta: </span>
                        <span class="subtitle-1 font-weight-bold">
                          {{ $getDeepObj(item, `jml_kasek_swasta`) || 0 }}
                        </span>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" md="2">
                  <div class="my-2">
                    <div><span class="caption grey--text">Sebaran Satuan Pendidikan Negeri</span></div>
                    <v-row no-gutters class="text-right">
                      <span class="subtitle-1 font-weight-bold mb-0">
                        {{ item && item.kuota_negeri }}
                      </span>
                    </v-row>
                    <div><span class="caption grey--text">Jumlah Diterima Negeri</span></div>
                    <v-row no-gutters class="text-right">
                      <span class="subtitle-1 font-weight-bold mb-0">
                        {{ item && item.jml_terima_negeri }}
                      </span>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" md="2">
                  <div class="my-2">
                    <div><span class="caption grey--text">Sebaran Satuan Pendidikan Swasta</span></div>
                    <v-row no-gutters class="text-right">
                      <span class="subtitle-1 font-weight-bold mb-0">
                        {{ item && item.kuota_swasta }}
                      </span>
                    </v-row>
                    <div><span class="caption grey--text">Jumlah Diterima Swasta</span></div>
                    <v-row no-gutters class="text-right">
                      <span class="subtitle-1 font-weight-bold mb-0">
                        {{ item && item.jml_terima_swasta }}
                      </span>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" md="2">
                  <div class="my-2">
                    <div><span class="caption grey--text">Total Sebaran Satuan Pendidikan</span></div>
                    <v-row no-gutters class="text-right">
                      <span class="subtitle-1 font-weight-bold mb-0">
                        {{ item && item.kuota }}
                      </span>
                    </v-row>
                    <div><span class="caption grey--text">Total Diterima</span></div>
                    <v-row no-gutters class="text-right">
                      <span class="subtitle-1 font-weight-bold mb-0">
                        {{ item && item.jml_terima }}
                      </span>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'list-pagu',
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped></style>
